const router = [
  {
    path: '/wage',
    component: () => import('@/views/wage/WorkArrange.vue'),
    redirect: '/wage/WorkArrange',
    children: [
      {
        path: 'workArrange',
        name: 'WorkArrange',
        component: () => import('@/views/wage/WorkArrange.vue'),
        meta: {
          title: '考勤排班',
          requiresAuth: true
        }
      }
    ]
  }
];
export default router;
